import React from "react";
import { Typography } from "@material-ui/core";
import styled from "styled-components";
import * as PropTypes from "prop-types";
import LeftIcon from "./visual/space-invader-teal-OberionIO.min.svg";
import CenterIcon from "./visual/heart-OberionIO.min.svg";
import RightIcon from "./visual/star-OberionIO.min.svg";
import { lessOrEqualThan } from "../util/mediaQuery";

const text = [
  "Your Discovery Stats",
  "Our Suggestions",
  "We recommended",
];

// TODO refactor User Stories in reusable component. Also used in index/Explainer
const UserStories = styled.div`
  display: flex;
  ${lessOrEqualThan.md` 
    flex-flow: column nowrap;
    justify-content: center; 
    align-items: center; 
    max-width: 28rem;
  `};
`;
const UserStory = styled.div`
  text-align: center;
  padding: 1rem 3rem 3rem 3rem;
  position: relative;
  max-width: 22rem;
`;
const Illustration = styled.img`
  box-sizing: border-box;
  display: block;
  height: 7rem;
  margin: 2rem auto 0 auto;
  width: auto;
`;

const Stats = ({ stats }) => {
  // console.log(stats);
  // console.log(stats[0]);
  return (
    <UserStories>
      <UserStory>
        <Illustration src={LeftIcon} />
        <Typography component="span" variant="h1" gutterBottom>{stats.number[0]}</Typography>
        <Typography variant="body2" paragraph>{stats.category[0]}</Typography>
        <Typography variant="body2">{stats.reason[0]}</Typography>
      </UserStory>

      <UserStory>
        <Illustration src={CenterIcon} />
        <Typography component="span" variant="h1" gutterBottom>{stats.number[1]}</Typography>
        <Typography variant="body2" paragraph>{stats.category[1]}</Typography>
        <Typography variant="body2">{stats.reason[1]}</Typography>
      </UserStory>

      <UserStory>
        <Illustration src={RightIcon} />
        <Typography component="span" variant="h1" gutterBottom>{stats.number[2]}</Typography>
        <Typography variant="body2" paragraph>{stats.category[2]}</Typography>
        <Typography variant="body2">{stats.reason[2]}</Typography>
      </UserStory>
    </UserStories>
  );
};
Stats.propTypes = {
  stats: PropTypes.shape({
    number: PropTypes.arrayOf(PropTypes.number).isRequired,
    category: PropTypes.arrayOf(PropTypes.string).isRequired,
    reason: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
};
export default Stats;